// extracted by mini-css-extract-plugin
module.exports = {"Dark":"Layout_Dark__HaYOp","Light":"Layout_Light___GxQK","Main":"Layout_Main__2zCf8"};